<jhi-data-filter *ngIf="filtersOptions" [filters]="filters" [options]="filtersOptions" (filtersChange)="filtersCurrentChanged($event)"></jhi-data-filter>

<jhi-bary-table-manager-action-button
  [tableOptions]="tableOptions"
  (orderChangeEvent)="changeOrder($event)"
  (newEvent)="createNew($event)"
  (newAndRedirectEvent)="createAndRedirect($event)"
  [items]="data"
></jhi-bary-table-manager-action-button>

<ng-container *ngIf="loaded">
  <jhi-refunds-list
    *ngIf="type === BaryTableDataEnum.REFUNDS"
    [basketOrders]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-refunds-list>
  <jhi-transporter-groups-list
    *ngIf="type === BaryTableDataEnum.SERVICES"
    [transporterGroups]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-transporter-groups-list>
  <jhi-upload-pricing-list
    *ngIf="type === BaryTableDataEnum.UPLOAD_PRICING_ITEMS || type === BaryTableDataEnum.CUSTOMER_PRICING"
    [pricingItems]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-upload-pricing-list>
  <jhi-acceptances-list
    *ngIf="type === BaryTableDataEnum.ACCEPTANCES"
    [acceptances]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-acceptances-list>
  <jhi-quotations-list
    *ngIf="type === BaryTableDataEnum.QUOTES"
    [transports]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-quotations-list>
  <jhi-cutoff-list
    *ngIf="type === BaryTableDataEnum.CUTOFFS"
    [cutOffs]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-cutoff-list>
  <jhi-display-message-moderator-list
    *ngIf="type === BaryTableDataEnum.NOTIFICATIONS"
    [messages]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-display-message-moderator-list>
  <jhi-merchandises-list
    *ngIf="type === BaryTableDataEnum.MERCHANDISES"
    [merchandises]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-merchandises-list>
  <jhi-insurance-items-list
    *ngIf="type === BaryTableDataEnum.OFFER_INSURANCE_ITEMS"
    [insuranceItems]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-insurance-items-list>
  <jhi-users-list
    *ngIf="type === BaryTableDataEnum.USERS"
    [users]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-users-list>
  <jhi-moderators-list
    *ngIf="type === BaryTableDataEnum.MODERATORS"
    [users]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-moderators-list>
  <jhi-impersonate-list
    *ngIf="type === BaryTableDataEnum.IMPERSONATE"
    [users]="getData()"
    [(pagination)]="pagination"
    [tableOptions]="tableOptions"
    (paginationChange)="transition()"
  ></jhi-impersonate-list>
  <ng-content></ng-content>
</ng-container>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)"></ngx-spinner>

<div class="row justify-content-center" *ngIf="pagination.page > 1 || (data && data.length && data.length >= this.ITEMS_PER_PAGE)">
  <ngb-pagination
    [collectionSize]="totalItems"
    [(page)]="pagination.page"
    [pageSize]="ITEMS_PER_PAGE"
    [maxSize]="5"
    [rotate]="true"
    [boundaryLinks]="true"
    (pageChange)="loadPage(pagination.page)"
  ></ngb-pagination>
</div>
